let infoCards = JSON.parse(document.querySelector('#info-cards-data').innerText).info_cards;
let currentInfoCardIndex = 0;

function createInfoCard(info) {
  let div = document.createElement('div');

  if (info.full_width) {
    div.className = 'info-card full-width';
    div.innerHTML = `
      <div class="info-card__media">
      <a href="${info.cta_link}">
        <img
        class="info-card__media-image"
        src="${info.image}"
        alt="${info.title}"
        >
      </a>
      </div>
      <div class="info-card__content" style="background-color:${info.background_color}">
        <a
        class="info-card__content-cta"
        style="color: ${info.text_color}; font-size:${info.font_size}" href="${info.cta_link}">
          ${info.cta_label}
        </a>
        <a href="${info.cta_link}">
        <h2 class="info-card__content-title" style="color:${info.text_color}">${info.title }</h2>
        </a>
      </div>
    `;
  } else {
    div.className = 'info-card no-full-width';
    div.innerHTML = `
      <div class="info-card__media">
      <a href="${info.cta_link}">
        <img
          class="info-card__media-image"
          src="${info.image}"
          alt="${info.title}"
          >
      </a>
      </div>
      <div class="info-card__content">
      <a href="${info.cta_link}">
        <h2 class="info-card__content-title">${info.title}</h2>
      </a>
        <a class="info-card__content-cta" style="font-size:${info.font_size}" href="${info.cta_link}">
          ${info.cta_label}
        </a>
      </div>
    `;
  }
  return div;
}

export function insertInfoCards() {
  console.log('insertInfo');

  let items = document.querySelectorAll('.item-product, .info-card');

  while (currentInfoCardIndex < infoCards.length) {
    let info = infoCards[currentInfoCardIndex];
    let position = parseInt(info.position, 10);
    if (position >= items.length) {
      break;
    }

    let target = items[position - 1];
    if (!target.classList.contains('info-card')) {
      let infoCard = createInfoCard(info);
      target.parentNode.insertBefore(infoCard, target);
    }

    currentInfoCardIndex++;
  }
}

window.infoCardsInit = insertInfoCards();
